import * as stringUtils from 'string';

export class ValidatorMapper {
  static validatorsMap = {
    'isNotEmpty': 'required',
    'isEmail': 'email',
    'isNumber': 'number',
  };

  public static map(validationResults: { [key: string]: string }): { [key: string]: string } {
    return Object.assign({},
      ...Object.keys(validationResults).map(key => {
        return {
          [ValidatorMapper.validatorsMap[key] || key]: stringUtils(validationResults[key] || key).humanize().toString()
        };
      })
    );
  }
}
